// Generated by ReScript, PLEASE EDIT WITH CARE


function fromString(vehicle) {
  switch (vehicle) {
    case "2_WHEELER" :
        return /* TWO_WHEELER */0;
    case "3_WHEELER" :
        return /* THREE_WHEELER */1;
    case "4_WHEELER" :
        return /* FOUR_WHEELER */2;
    default:
      return /* FOUR_WHEELER */2;
  }
}

export {
  fromString ,
  
}
/* No side effect */
